export function normalizePath(path) {
  if (!path) return path;

  let normalized = path.replace(/\\/g, '/');

  if (!normalized.startsWith('/')) {
    normalized = '/' + normalized;
  }

  return normalized;
}

export function getFileExtension(path) {
  if (!path) return '';
  const lastDot = path.lastIndexOf('.');
  if (lastDot === -1) return '';
  return path.slice(lastDot + 1).toLowerCase();
}

export function isHtmlFile(path) {
  const ext = getFileExtension(path);
  return ext === 'html' || ext === 'htm';
}

export function isCssFile(path) {
  return getFileExtension(path) === 'css';
}

export function isJsFile(path) {
  return getFileExtension(path) === 'js';
}

export function getLanguageFromPath(path) {
  const ext = getFileExtension(path);

  switch (ext) {
    case 'html':
    case 'htm':
      return 'html';
    case 'css':
      return 'css';
    case 'js':
      return 'javascript';
    default:
      return 'text';
  }
}

export function normalizeUrl(url) {
  if (!url) return url;
  if (!/^[a-zA-Z]+:/i.test(url)) {
    return 'https://' + url;
  }
  return url;
}
